module.exports = __webpack_public_path__ + "media/promo/advent/images/logo-2-4f2cbe87b5245d214d533540d74727d6.png";